import React from 'react';
import classNames from 'classnames';
import { getBountyRecommandation } from 'modules/App/utils/pricing';
import Tooltip from 'rc-tooltip';

type BountyRecommandationProps = React.HTMLAttributes<HTMLDivElement> & {
  salaryMin: number;
  salaryMax: number;
  isUrgent: boolean;
  bounty: number;
  bountyDescription?: string;
};

const BountyRecommandation: React.FC<BountyRecommandationProps> = ({
  children,
  className,
  salaryMin,
  salaryMax,
  isUrgent,
  bounty,
  bountyDescription,
  ...props
}) => {
  const bountyRecommandation = getBountyRecommandation({
    salaryMin,
    salaryMax,
    isUrgent,
    bounty,
  });

  const status = bountyRecommandation.recommendedBounty < bounty ? 'success' : 'error';

  return (
    <div className={classNames('max-w-[110px] mx-auto text-center', className)} {...props}>
      <Tooltip
        placement="bottom"
        trigger={['click', 'hover']}
        overlayClassName="opacity-100"
        overlay={
          <div className="max-w-[300px] p-2">
            <h2 className={classNames('font-bold text-sm', { 'text-success': status === 'success', 'text-warning': status === 'error' })}>
              {status === 'success' ? 'Le montant de la prime est approuvé par Headlinker' : 'Prime non approuvée par Headlinker'}
            </h2>
            <p className="mt-1 text-sm text-gray-900">
              {status === 'success' ? (
                <span>Le montant de cette prime semble cohérent avec les standards de l’industrie</span>
              ) : (
                <>
                  <span>
                    Le montant de cette prime nous semble faible et le <strong>recruteur en a été informé lors de la création</strong>.
                    {bountyDescription && ` Il a ajouté ce message pour motiver son choix :`}
                  </span>
                  {bountyDescription && <cite>{bountyDescription}</cite>}
                </>
              )}
            </p>
            <p className="mt-3 italic text-sm text-faded">
              Si tu souhaites prendre en charge le sourcing, mais à un prix + élevé, n’hésite pas à lui faire une contre proposition.
            </p>
          </div>
        }
      >
        <div>
          {children}
          <div
            className={classNames('text-xs mt-1 font-bold border border-solid rounded-md px-0.5', {
              'text-success border-success': status === 'success',
              'text-gray-500 border-gray-500': status === 'error',
            })}
          >
            {status === 'success' ? 'Prime approuvée' : 'Prime standard'}
          </div>
        </div>
      </Tooltip>
    </div>
  );
};

export default BountyRecommandation;
